module.exports = __webpack_public_path__ + "static/media/Yeongwol1.5e737456.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/pages/Surroundings/assets/Yeongwol1.jpeg
// module id = 583
// module chunks = 0